import React from 'react'

import { Navigate, Route, Routes } from 'react-router-dom'

import Login from '../components/Admin/Login/Login'
import ForgetPassword from '../components/Admin/Login/ForgetPassword'
import ResetPassword from '../components/Admin/Login/ResetPassword'
import Dashboard from '../components/Admin/Dashboard/Dashboard'
import FirmList from '../components/Admin/Firm/FirmList'
import ManageFirm from '../components/Admin/Firm/ManageFirm'
import EmployeeList from '../components/Admin/Employee/EmployeeList'
import ManageEmployee from '../components/Admin/Employee/ManageEmployee'
import SalaryList from '../components/Admin/Salary/SalaryList'
import ManageSalary from '../components/Admin/Salary/ManageSalary'
import HolidayList from '../components/Admin/Holiday/HolidayList'
import ManageHoliday from '../components/Admin/Holiday/ManageHoliday'
import WorkDayList from '../components/Admin/WorkDay/WorkDayList'
import ManageWorkday from '../components/Admin/WorkDay/ManageWorkday'
import Otp from '../components/Admin/Login/Otp'
import Profile from '../components/Admin/Profile/Profile'
import YearList from '../components/Admin/Year/YearList'
import ManageYear from '../components/Admin/Year/ManageYear'
import UserList from '../components/Admin/User/UserList'
import ManageUser from '../components/Admin/User/ManageUser'
import AdminEditProfile from '../components/Admin/Profile/AdminEditProfile'
import Storage from '../components/Admin/Store/Store'
import ManageStorage from '../components/Admin/Store/ManageStore'
import ProjectList from '../components/Admin/Project/ProjectList'
import ManageProject from '../components/Admin/Project/ManageProject'

import BankList from '../components/Admin/PayrollMaster/Bank/BankList';
import ManageBank from '../components/Admin/PayrollMaster/Bank/ManageBank';
import CategoryList from '../components/Admin/PayrollMaster/Category/CategoryList';
import ManageCategory from '../components/Admin/PayrollMaster/Category/ManageCategory';
import GroupList from '../components/Admin/PayrollMaster/Group/GroupList';
import ManageGroup from '../components/Admin/PayrollMaster/Group/ManageGroup';
import DepartmentList from '../components/Admin/PayrollMaster/Department/DepartmentList';
import ManageDepartment from '../components/Admin/PayrollMaster/Department/ManageDepartment';
import DesignationList from '../components/Admin/PayrollMaster/Designation/DesignationList';
import ManageDesignation from '../components/Admin/PayrollMaster/Designation/ManageDesignation';
import ShiftList from '../components/Admin/PayrollMaster/Shift/ShiftList';
import ManageShift from '../components/Admin/PayrollMaster/Shift/ManageShift';
import AuthPersonList from '../components/Admin/PayrollMaster/AuthPerson/AuthPersonList';
import ManageAuthPerson from '../components/Admin/PayrollMaster/AuthPerson/ManageAuthPerson';
import SkillList from '../components/Admin/PayrollMaster/Skill/Skill';
import ManageSkill from '../components/Admin/PayrollMaster/Skill/ManageSkill';
import EmployeeTypeList from '../components/Admin/PayrollMaster/EmployeeType/EmployeeType';
import ManageEmployeeType from '../components/Admin/PayrollMaster/EmployeeType/ManageEmployeeType';

import EarningList from '../components/Admin/Earning/Earning';
import ManageEarning from '../components/Admin/Earning/ManageEarning';
import DeductionList from '../components/Admin/Deduction/Deduction';
import ManageDeduction from '../components/Admin/Deduction/ManageDeduction';
import LoanList from '../components/Admin/Loan/Loan';
import ManageLoan from '../components/Admin/Loan/ManageLoan';
import LoanStatus from '../components/Admin/Loan/LoanStatus';
import PartyBillList from '../components/Admin/PartyBill/PartyBill';
import ManagePartyBill from '../components/Admin/PartyBill/ManagePartyBill';


const Admin = () => {
    return (
        <>
            <Routes>
                <Route path="/admin" element={<Navigate to="/admin/dashboard" />} />

                {/* Auth */}
                <Route path='/admin/login' element={<Login />} />
                <Route path='/admin/forget-password' element={<ForgetPassword />} />
                <Route path='/admin/reset-password' element={<ResetPassword />} />
                <Route path='/admin/otp-verification' element={<Otp />} />

                {/* Dashboard */}
                <Route path='/admin/dashboard' element={<Dashboard />} />
                <Route path='/admin/profile' element={<Profile />} />
                <Route path='/admin/edit-profile' element={<AdminEditProfile />} />

                {/* Firm */}
                <Route path='/admin/firm-management' element={<FirmList />} />
                <Route path='/admin/manage-firm' element={<ManageFirm />} />

                {/* Project */}
                <Route path='/admin/project-management' element={<ProjectList />} />
                <Route path='/admin/manage-project' element={<ManageProject />} />

                {/* Employee */}
                <Route path='/admin/employee-management' element={<EmployeeList />} />
                <Route path='/admin/manage-employee' element={<ManageEmployee />} />

                {/* Salary */}
                <Route path='/admin/salary-management' element={<SalaryList />} />
                <Route path='/admin/manage-salary' element={<ManageSalary />} />

                {/* Work Day */}
                <Route path='/admin/work-day-management' element={<WorkDayList />} />
                <Route path='/admin/manage-work-day' element={<ManageWorkday />} />

                {/* Holiday */}
                <Route path='/admin/holiday-management' element={<HolidayList />} />
                <Route path='/admin/manage-holiday' element={<ManageHoliday />} />

                {/* Year */}
                <Route path='/admin/year-management' element={<YearList />} />
                <Route path='/admin/manage-year' element={<ManageYear />} />

                {/* User */}
                <Route path='/admin/user-management' element={<UserList />} />
                <Route path='/admin/manage-user' element={<ManageUser />} />

                {/* Storage */}
                <Route path='/admin/store-management' element={<Storage />} />
                <Route path='/admin/manage-store' element={<ManageStorage />} />

                {/* Payroll Master */}
                <Route path='/admin/bank-management' element={<BankList />} />
                <Route path='/admin/manage-bank' element={<ManageBank />} />
                <Route path='/admin/category-management' element={<CategoryList />} />
                <Route path='/admin/manage-category' element={<ManageCategory />} />
                <Route path='/admin/group-management' element={<GroupList />} />
                <Route path='/admin/manage-group' element={<ManageGroup />} />
                <Route path='/admin/department-management' element={<DepartmentList />} />
                <Route path='/admin/manage-department' element={<ManageDepartment />} />
                <Route path='/admin/designation-management' element={<DesignationList />} />
                <Route path='/admin/manage-designation' element={<ManageDesignation />} />
                <Route path='/admin/shift-management' element={<ShiftList />} />
                <Route path='/admin/manage-shift' element={<ManageShift />} />
                <Route path='/admin/authorized-person-management' element={<AuthPersonList />} />
                <Route path='/admin/manage-authorized-person' element={<ManageAuthPerson />} />
                <Route path='/admin/skill-management' element={<SkillList />} />
                <Route path='/admin/manage-skill' element={<ManageSkill />} />
                <Route path='/admin/employee-type-management' element={<EmployeeTypeList />} />
                <Route path='/admin/manage-employee-type' element={<ManageEmployeeType />} />

                {/* Earning */}
                <Route path='/admin/earning-management' element={<EarningList />} />
                <Route path='/admin/manage-earning' element={<ManageEarning />} />

                {/* Deduction */}
                <Route path='/admin/deduction-management' element={<DeductionList />} />
                <Route path='/admin/manage-deduction' element={<ManageDeduction />} />

                {/* Loan */}
                <Route path='/admin/loan-management' element={<LoanList />} />
                <Route path='/admin/manage-loan' element={<ManageLoan />} />
                <Route path='/admin/loan-status' element={<LoanStatus />} />

                {/* Party Bill */}
                <Route path='/admin/party-bill-management' element={<PartyBillList />} />
                <Route path='/admin/manage-party-bill' element={<ManagePartyBill />} />

                <Route path="/admin/*" element={<Navigate to="/admin/dashboard" />} />
            </Routes>
        </>
    )
}

export default Admin